import createSelectors from './createSelectors';
import ReportSchedule from '../models/ReportSchedule';

const Select = createSelectors(ReportSchedule, {});

export default Select;
